import { useState, useLayoutEffect } from "react";

export interface WindowResize {
  width: number;
  height: number;
}

function useWindowResize(): WindowResize {
  const [windowSize, setWindowSize] = useState<WindowResize>({
    width: 0,
    height: 0,
  });

  useLayoutEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}

export default useWindowResize;
